// Date helpers that avoid the UTC off-by-one bug.
//
// A date-only string like "2026-04-18" is parsed by `new Date(...)` as UTC
// midnight. When formatted in a timezone behind UTC (e.g. Mexico, UTC-6) it
// renders the PREVIOUS day ("17 de abril"). These helpers parse date-only
// strings as LOCAL midnight so the displayed day matches what the admin set.

export function parseLocalDate(value) {
  if (!value) return null;
  const s = String(value);
  // Pure date (YYYY-MM-DD) → build at local midnight.
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  // Datetime that starts with a date but has no timezone info → also local.
  const dm = s.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  if (dm && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) {
    return new Date(Number(dm[1]), Number(dm[2]) - 1, Number(dm[3]), Number(dm[4]), Number(dm[5]));
  }
  return new Date(s);
}

// Long Spanish/English date: "18 de abril de 2026".
export function formatLongDate(value, locale = 'es') {
  const d = parseLocalDate(value);
  if (!d || Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(locale === 'en' ? 'en-US' : 'es-MX', {
    year: 'numeric', month: 'long', day: 'numeric',
  });
}
